import { Navigate, useParams } from "react-router-dom";

/** Legacy route — redirects to unified request detail */
export default function InvestorInvestmentRequestDetailRedirect() {
  const { requestId } = useParams();
  return <Navigate to={`/invest/requests/${requestId}`} replace />;
}
